import { z } from 'zod';
/**
 * A director or professor sending a personal (custom) notification to a single
 * student. Validated at the API boundary; the recipient is identified by their
 * student id and the title/body are free text.
 */
export const sendCustomNotificationSchema = z.object({
    student_id: z.string().uuid(),
    title: z.string().trim().min(1, 'El título es obligatorio').max(120, 'Máximo 120 caracteres'),
    body: z.string().trim().min(1, 'El mensaje es obligatorio').max(1000, 'Máximo 1000 caracteres'),
    /**
     * Delivery channels. In-app is ALWAYS sent (it is the platform inbox) and is
     * not configurable here; these add extra delivery. Email is delivered if
     * Resend is configured; push if the student registered a device token.
     */
    channels: z
        .object({
        email: z.boolean(),
        push: z.boolean(),
    })
        .default({ email: false, push: false }),
});
//# sourceMappingURL=notification.schema.js.map